// extracted by mini-css-extract-plugin
module.exports = {"comingSoonInfo":"styles_comingSoonInfo__TrNs4","comingSoonInfo__title":"styles_comingSoonInfo__title__Rsw5a"};